import { render, staticRenderFns } from "./fake-leads.vue?vue&type=template&id=4f91b9f0&"
import script from "./fake-leads.vue?vue&type=script&lang=js&"
export * from "./fake-leads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports